import $ from "jquery";

import SiteHeader from "./components/site-header";
import TestimoniesSlider from "./components/testimonies-slider";
import DualColumnSlider from "./components/dual-column-slider";
import ReassurancesSlider from "./components/reassurances-slider";
import CookiesConsent from "./components/cookies-consent";
import Accordion from "./components/accordion";
import ScrollInView from "./components/scroll-in-view";
import DeviceManager from "./utils/device-manager";
import Form from "./components/form";
import "./components/numero-cristal";
import "./components/tracking"

$(function () {
	const bootstrapApp = () => {
		const $html = $("html");

		// Touch device detection
		if (DeviceManager.isHandheld()) {
			$html.addClass("touch");

			if (DeviceManager.isIos()) {
				$html.addClass("ios");
			}
		} else {
			$html.addClass("no-touch");
		}

		// IE detection
		if (DeviceManager.isIe11()) {
			$html.addClass("ie11");
		} else if (DeviceManager.isEdge()) {
			$html.addClass("edge");
		}
	};

	const instanciateComponents = () => {
		// General components
		const siteHeader = new SiteHeader($(".site-header"), 20);

		// Testimonies slider component
		const $testimoniesSlider = $(".testimonies_list");
		if ($testimoniesSlider.length) {
			$testimoniesSlider.each(function (index, el) {
				const testimonySlider = new TestimoniesSlider($(el));
			});
		}
		
		// Reassurances slider component
		const $reassurancesSlider = $(".reassurances-section__wrapper");
		if ($reassurancesSlider.length) {
			$reassurancesSlider.each(function (index, el) {
				const reassuranceSlider = new ReassurancesSlider($(el));
			});
		}

		// Dual column slider component
		const $dualcolumnsSlider = $(".dual-column-section__wrapper");
		if ($dualcolumnsSlider.length) {
			$dualcolumnsSlider.each(function (index, el) {
				const dualcolumnSlider = new DualColumnSlider($(el));
			});
		}

		// Cookie consent
		if (typeof tarteaucitron !== "undefined" && tarteaucitron) {
			// Tarteaucitron cookie settings
			let tarteaucitronLang = "fr";

			const cookiesConsent = new CookiesConsent(tarteaucitronLang);
		}

		// Scroll in view component
		/* const $scrollInViewElements = $(".scroll-in-view");
		if ($scrollInViewElements.length) {
			$scrollInViewElements.imagesLoaded(function () {
				const scrollInView = new ScrollInView($scrollInViewElements);
			});
		} */

		if ($( 'body' )) {
			if($('.reassurances-section__single').length) {
				$(window).on('scroll', function (e) {
					if($(window).scrollTop() >= $('.reassurances-section__single').offset().top - 800){
						$('.reassurances-section__single').addClass('active');
					}
				});
			}
			if($('.dual-column-section__image').length) {
				$(window).on('scroll', function (e) {
					if($(window).scrollTop() >= $('.dual-column-section__image').offset().top - 800){
						$('.dual-column-section__image').addClass('active');
					}
				});
			}
			if($('.videos-section').length) {
				$(window).on('scroll', function (e) {
					if($(window).scrollTop() >= $('.videos-section').offset().top - 800){
						$('.video').addClass('active');
					}
				});
			}
			if($('.testimonies-images').length) {
				$(window).on('scroll', function (e) {
					if($(window).scrollTop() >= $('.testimonies-images').offset().top - 800){
						$('.testimonies-images').addClass('active');
					}
				});
			}
		}

		// Get latest word to h1 on front page to apply svg on it
		$('.homepage-introduction__title h2').html(function(){	
			// separate the text by spaces
			var text= $(this).text().split(' ');
			// drop the last word and store it in a variable
			var amount_to_remove = 2;
			var last = text.splice(text.length - amount_to_remove, amount_to_remove).join(" ");
			// join the text back and if it has more than 1 word add the span tag
			// to the last word
			return text.join(" ") + (text.length > 0 ? '<p class="text-over">' + last + '</p>' : last);   
		});
		$('h1').html(function(){	
			var text= $(this).text().split(' ');
			var last = text.pop();

			// Si moins de 10 charactères alors on n'affiche pas le background
			if(last.length < 7 ) {
				return text.join(" ") + ('<p class="text-over no-background">' + last + '</p>');   
			} else if(last.length > 7 ) {
				return text.join(" ") + (text.length > 0 ? '<p class="text-over">' + last + '</p>' : last);   
			} else {
				return text.join(" ") + (text.length > 0 ? '<p class="text-over small">' + last + '</p>' : last);   

			} endif;
			
		});
		$('.dual-column-section__title h2').html(function(){
			var text= $(this).text().split(' ');	
			var last = text.pop();
			return text.join(" ") + (text.length > 0 ? '<span class="text-over-background">' + last + '</span>' : last);   
		});

		//Suppression de l'affichage de la distinction des CP du formulaire
		$('.gfield_label:contains("Particuliers")').html(function() {
			var text = $(this).text().split(' ');
			var last = text.pop();
			return text.join(" ");
		});
		$('.gfield_label:contains("Professionnels")').html(function() {
			var text = $(this).text().split(' ');
			var last = text.pop();
			return text.join(" ");
		});
	};

	bootstrapApp;
	instanciateComponents();
});

